<template>
  <div class="mt-5" style="margin-top: 4em">
<!--    <div class="hero-w hero-w-sub">-->
<!--      <div class="hero hero-3 wf-section">-->
<!--        <div class="container">-->
<!--          <div class="hh-co">-->
<!--            <h1 class="hh1 mb">Údaje žiadosti</h1>-->
<!--            <div class="sp"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container">
<!--      <div class="c mb-x" style="display: none">-->
<!--        <h2>ROZSAH POISTENIA</h2>-->
<!--        <table class="table table-striped">-->
<!--          <tr>-->
<!--            <td>Typ poistenia</td>-->
<!--            <td>{{ productTypeFormatted }}</td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td>Doba trvania poistenia</td>-->
<!--            <td> {{ configuration.duration_in_months }} mesiacov</td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td>Doba trvania 1 cesty</td>-->
<!--            <td> bez obmedzenia</td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td>Prerušenie cesty</td>-->
<!--            <td>{{ tripCancellationFormatted }}</td>-->
<!--          </tr>-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td rowspan="4">Poistené činnosti</td>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>manuálna práca</td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>administratívna práca</td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>rekreačné športy</td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>turistika</td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td rowspan="4">Nie sú poistené</td><td> rizikové športy</td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>súťažné športy</td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>chronické ochorenia</td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>pátranie a záchrana v horách</td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>Vek poistenej osoby</td><td> do 70 rokov</td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--&lt;!&ndash;          <tr>&ndash;&gt;-->
<!--&lt;!&ndash;            <td>Územný rozsah</td><td> Európa – geografické územie okrem Slovenska, okrem krajiny kde má klient trvalý pobyt a krajiny ktorej je štátnym občanom</td>&ndash;&gt;-->
<!--&lt;!&ndash;          </tr>&ndash;&gt;-->
<!--          <tr>-->
<!--            <td>Celková cena poistenia</td><td> {{ priceFormatted }} <br></td>-->

<!--          </tr>-->
<!--          <tr><td colspan="2">vrátane dane z neživotného poistenia vo výške 8%</td></tr>-->
<!--        </table>-->
<!--      </div>-->
      <div class="c mb-x">
        <div class="w-form">
          <form id="email-form" name="email-form" data-name="Email Form" method="get"
                data-wf-page-id="67d2dad646cb62dbd2841fb7" data-wf-element-id="0691bc90-fcd9-d7f1-d3a2-b97d10e2d893"
                aria-label="Email Form">
            <div class="cx">
              <div class="col-13"><h2 class="h4 mb">Meno a priezvisko dojednávateľa</h2></div>
              <div class="col-23">
                <div class="con">
                  <div class="col-12"><label for="name-3" class="label">Meno</label><input type="text" v-model="formData.name"
                                                                                           :class="{ 'is-invalid': v$.formData.name.$error  }"
                                                                                           class="in w-input in_trv" maxlength="256" name="name" data-name="Name 2" placeholder="" id="name-2">
                                                                                     <div class="invalid-feedback">{{$t("validation.required") }}</div>
                  </div>
                  <div class="col-12"><label for="name-3" class="label">Priezvisko</label><input type="text" v-model="formData.surname"
                                                                                                 :class="{ 'is-invalid': v$.formData.surname.$error  }"
                                                                                                 class="in in_trv w-input" maxlength="256" name="surname" data-name="Name 2" placeholder="" id="name-2">
                    <div class="invalid-feedback">{{$t("validation.required") }}</div></div>
                </div>
              </div>
            </div>
            <div class="cx_sep"></div>

            <div class="cx">
              <div class="col-13"><h2 class="h4 mb">Adresa trvalého pobytu</h2></div>
              <div class="col-23">
                <div class="con mb">
                  <div class="col-12"><label for="name-3" class="label">Ulica</label><input type="text" v-model="formData.address.street"
                                                                                            :class="{ 'is-invalid': v$.formData.address.street.$error  }"
                                                                                            class="in in_trv w-input" maxlength="256" name="street" data-name="Name 2" placeholder="" id="name-3">
                    <div class="invalid-feedback">{{$t("validation.required") }}</div></div>
                  <div class="col-12"><label for="name-3" class="label">Číslo domu</label><input type="text" v-model="formData.address.street_number"
                                                                                                 :class="{ 'is-invalid': v$.formData.address.street_number.$error  }"
                                                                                                 class="in in_trv w-input" maxlength="256" name="street_number" data-name="Name 2" placeholder="" id="name-2">
                    <div class="invalid-feedback">{{$t("validation.required") }}</div></div>
                </div>
                <div class="con">
                  <div class="col-12"><label for="name-3" class="label">Mesto</label>
                    <input type="text" v-model="formData.address.town"
                           :class="{ 'is-invalid': v$.formData.address.town.$error  }"
                           class="in in_trv w-input" maxlength="256" name="town" data-name="Name 2" placeholder="" id="name-3">
                    <div class="invalid-feedback">{{$t("validation.required") }}</div>
                  </div>
                  <div class="col-12"><label for="name-33" class="label">PSČ</label>
                    <input type="text" v-model="formData.address.zip"
                           :class="{ 'is-invalid': v$.formData.address.zip.$error  }"
                           class="in in_trv w-input" maxlength="256" name="zip" data-name="Name 2" placeholder="" id="name-33">
                    <div class="invalid-feedback">{{$t("validation.zip") }}</div></div>
                </div>
              </div>
            </div>
            <div class="cx_sep"></div>
            <div class="cx">
              <div class="col-13"><h2 class="h4 mb">Osobné údaje</h2></div>
              <div class="col-23">
                <div class="con mb">
                  <div class="col-12 national-id-wrapper">
                    <label for="name-3" class="label">Rodné číslo</label>
                    <input type="text" v-model="formData.national_id"
                           class="in in_trv w-input" maxlength="256" name="national_id" data-name="Name 2" placeholder="" id="name-2">
                    <div class="invalid-feedback" v-if="v$.formData.national_id.nationalIdRule.$invalid && v$.formData.national_id.$dirty">{{$t("validation.national_id") }}</div>
                    <div class="invalid-feedback" v-if="v$.formData.national_id.matured.$invalid && v$.formData.national_id.$dirty">Poistenie osoby mladšej ako 18 rokov môže dojednať dospelá osoba.</div>
                  </div>
                  <div class="col-12"><label for="name-3" class="label">Štátna príslušnosť</label>
                    <select class="in in_trv w-select" v-model="formData.nationality"
                            id="person_nationality">
                      <option v-for="(label, code) in countryList" :value="code" :key="code">{{ label }}</option>
                    </select>
                  </div>
                </div>
                <div class="con">
                  <div class="col-12">
                    <label for="name-3" class="label">Číslo občianskeho preukazu</label>
                    <input type="text" v-model="formData.id_card"
                           :class="{ 'is-invalid': v$.formData.id_card.$error  }"
                           class="in in_trv w-input" maxlength="256" name="id_card" data-name="Name 2" placeholder="" id="name-2">
                    <div class="invalid-feedback">{{$t("validation.required") }}</div>
                  </div>
                </div>
              </div>
            </div>

<!--            <div class="cx_sep"></div>-->
<!--            <div class="cx">-->
<!--              <div class="col-13"><h2 class="h4 mb">Poistenie</h2></div>-->
<!--              <div class="col-23">-->
<!--                <div class="con">-->
<!--                  <div class="col-12"><label for="name-3" class="label">Začiatok poistenia</label>-->
<!--                    <DatePickerWrap @input="formData.insurance_from = $event"-->
<!--                                    :min-date="insuranceStartMin"  :error="v$.formData.insurance_from.$error" />-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
            <div class="cx_sep"></div>
            <div class="cx">
              <div class="col-13"><h2 class="h4 mb">Poistené osoby</h2></div>
              <div class="col-23">
                <div class="row">
                  <TripCompanion v-for="(person, index) in formData.travellers"
                                 ref="tripCompanions"
                                 :index="index"
                                 :ageAbove70="configuration.age_above_70"
                                 :key="person.id"
                                 :trip-ends-at="configuration.insurance_to"
                                 :can-remove="formData.travellers.length > 1"
                                 :person="person"
                                 @remove="formData.travellers.splice(index, 1)"
                                 @loadFromOrder="loadPersonFromOrder()"

                                 @changeData="this.formData.travellers[index] = $event">

                  </TripCompanion>
                </div>
                <!--                <button v-if="canAdd" class="btn-light btn mt-3" @click.stop.prevent="addPerson">{{ $t('order.addPerson') }}</button>-->
                <!--                <div class="con">-->
                <!--                  <div class="col-12"><label for="name-3" class="label">Meno</label><input type="text" v-model="formData.name"-->
                <!--                                                                                           :class="{ 'is-invalid': v$.formData.name.$error  }"-->
                <!--                                                                                           class="in w-input in_trv" maxlength="256" name="name-2" data-name="Name 2" placeholder="" id="name-2">-->
                <!--                    <div class="invalid-feedback">{{$t("validation.required") }}</div>-->
                <!--                  </div>-->
                <!--                  <div class="col-12"><label for="name-3" class="label">Priezvisko</label><input type="text" v-model="formData.surname"-->
                <!--                                                                                                 :class="{ 'is-invalid': v$.formData.surname.$error  }"-->
                <!--                                                                                                 class="in in_trv w-input" maxlength="256" name="name-2" data-name="Name 2" placeholder="" id="name-2">-->
                <!--                    <div class="invalid-feedback">{{$t("validation.required") }}</div></div>-->
                <!--                </div>-->

              </div>
            </div>
            <div class="cx_sep"></div>
            <div class="cx">
              <div class="col-13"><h2 class="h4 mb">Kontaktné údaje</h2></div>
              <div class="col-23">
                <div class="con">
                  <div class="col-12"><label for="name-3" class="label">E-mail</label>
                    <input type="text" v-model="formData.email"
                           :class="{ 'is-invalid': v$.formData.email.$error  }"
                           class="in w-input in_trv" maxlength="256" name="email" data-name="Name 2" placeholder="" id="name-2">
                    <div class="invalid-feedback">{{$t("validation.email") }}</div>
                  </div>
                  <div class="col-12"><label for="name-3" class="label">Telefón</label>
                    <input type="text" v-model="formData.tel"
                           :class="{ 'is-invalid': v$.formData.tel.$error  }"
                           class="in w-input in_trv" maxlength="256" name="tel" data-name="Name 2" placeholder="" id="name-2">
                    <div class="invalid-feedback">{{$t("validation.tel") }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cx_sep"></div>
            <div class="cx">
              <div class="col-13"><h2 class="h4 mb">Doplňujúca informácia</h2></div>
              <div class="col-23">
                <div class="con">
                  <div class="col-12"><label for="name-3" class="label"></label>
                    <input type="text" class="in in_trv w-input" v-model="formData.action_code"
                           :class="{ 'in': true, 'w-input': true, 'is-invalid': v$.formData.action_code.$error  }"
                           maxlength="256" name="name-2" data-name="Name 2" placeholder="" id="name-2">
                  </div>
                </div>
              </div>
            </div>
            <div class="cx_sep"></div>
          </form>
        </div>
        <div class="con mb-x">
          <div>
            <div class="h4">Na vami zadanú mailovú adresu Vám posielame potvrdenie o uzatvorení poistenia, poistné
              podmienky a všetky informačné povinnosti a prosíme Vás o ich preštudovanie. Úhradou poistného zároveň
              prehlasujete, že ste boli úplne, zrozumiteľne a v dostatočnom časovom predstihu oboznámený s ich znením a
              boli Vám vysvetlené všetky ustanovenia v nich obsiahnuté.
            </div>
          </div>
        </div>
        <div class="con mb-x">
          <div>
            <div class="w-form">
<!--              <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get"-->
<!--                    data-wf-page-id="67d2dad646cb62dbd2841fb7" data-wf-element-id="ac20d146-8d3f-2eee-48a0-a29acc2810c2"-->
<!--                    aria-label="Email Form 2"><label class="w-checkbox chw">-->
<!--                <div class="w-checkbox-input w-checkbox-input&#45;&#45;inputType-custom chb cb_trv"></div>-->
<!--                <input type="checkbox" id="checkbox" name="checkbox" data-name="Checkbox"-->
<!--                       style="opacity:0;position:absolute;z-index:-1"><span class="chl w-form-label" for="checkbox">Súhlasím s elektronickou komunikáciou, informácie súvisiace s poskytovaním finančných služieb mi budú zaslané na mailovú adresu, ktorú som zadal. Potvrdzujem, že k tejto schránke elektronickej pošty mám pravidelný prístup.</span></label>-->
<!--              </form>-->

                                <label class="w-checkbox chw">
                                <div :class="{'w-checkbox-input': true, 'w-checkbox-input--inputType-custom': true, 'chb': true, 'cb_trv': true, 'w--redirected-checked': formData.agree_gdpr_basic }"></div>
                                <input type="checkbox" id="checkbox"  v-model="formData.agree_gdpr_basic" name="agree_gdpr" data-name="Checkbox" style="opacity:0;position:absolute;z-index:-1">
                                <span class="chl w-form-label" for="checkbox">Súhlasím s elektronickou komunikáciou, informácie súvisiace s poskytovaním finančných služieb mi budú zaslané na mailovú adresu, ktorú som zadal. Potvrdzujem, že k tejto schránke elektronickej pošty mám pravidelný prístup.
                                </span>
                                  <div :class="{'invalid-feedback': true, 'd-block': v$.formData.agree_gdpr_basic.$error}" >{{$t("validation.required") }}</div>
                              </label>

            </div>
            <div class="w-form">
              <!--              <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get"-->
              <!--                    data-wf-page-id="67d2dad646cb62dbd2841fb7" data-wf-element-id="ac20d146-8d3f-2eee-48a0-a29acc2810c2"-->
              <!--                    aria-label="Email Form 2"><label class="w-checkbox chw">-->
              <!--                <div class="w-checkbox-input w-checkbox-input&#45;&#45;inputType-custom chb cb_trv"></div>-->
              <!--                <input type="checkbox" id="checkbox" name="checkbox" data-name="Checkbox"-->
              <!--                       style="opacity:0;position:absolute;z-index:-1"><span class="chl w-form-label" for="checkbox">Súhlasím s elektronickou komunikáciou, informácie súvisiace s poskytovaním finančných služieb mi budú zaslané na mailovú adresu, ktorú som zadal. Potvrdzujem, že k tejto schránke elektronickej pošty mám pravidelný prístup.</span></label>-->
              <!--              </form>-->

              <label class="w-checkbox chw">
                <div :class="{'w-checkbox-input': true, 'w-checkbox-input--inputType-custom': true, 'chb': true, 'cb_trv': true, 'w--redirected-checked': formData.payment_protection }"></div>
                <input type="checkbox" id="checkbox"  v-model="formData.payment_protection" name="payment_protection" data-name="Checkbox" style="opacity:0;position:absolute;z-index:-1">
                <span class="chl w-form-label" for="checkbox">V súlade s ustanovením § 35 odsek 1 Zákona č. 186/2009 v platnom znení prehlasujem, že moja finančná situácia mi umožňuje uhrádzať poistné uvedené vyššie.
                                </span>
                <div :class="{'invalid-feedback': true, 'd-block': v$.formData.payment_protection.$error}" >{{$t("validation.required") }}</div>
              </label>

            </div>
          </div>
        </div>
      </div>
<!--      {{ v$.$errors }}-->
<!--      {{ this.product }}-->

      <div class="submit-actions">
        <div v-if="submitError" class="submit-error">{{ submitError }}</div>
        <button class="btn btn_trv w-inline-block" @click="sendDataToServer" :disabled="sending" id="send_data_button">
          <div class="mr">Odoslať</div>
          <div class="ico ico-r"></div>
        </button>
      </div></div>

      <br><br><br><br>

  </div>

</template>

<script>
//import DatePickerWrap from "@/components/parts/DatePickerWrap";
import { rodnecislo } from 'rodnecislo';
//import FormStepTitle from "@/components/parts/FormStepTitle";
//import NavigationPart from "@/components/parts/NavigationPart";
import useValidate from "@vuelidate/core";
import { required, email, alphaNum } from "@vuelidate/validators";
import axios from "axios";
import common from "@/config/common";
import TripCompanion from "@/components/TripCompanion.vue";
const nationalIdRule = (value) => {
  return rodnecislo(value).isValid(); // && rodnecislo(value).age() <= 70
}
const checkRule = (value) => value;
const telRule = (value) => {
  if(!value?.length) return true;
  value = value.replace(/ /g, "");
  return !value || value.match(/^\+(\d){3}[0-9]{9}$/);
}
const zipRule = (value) => value.match(/^[0-9 ]{5,6}$/)

var countries = require("i18n-iso-countries");
export default {
  name: "ApplicationComponent",
  components: {TripCompanion},//FormStepTitle, NavigationPart
  props: {
    configuration: Object,
    price: Number,
    //suppose data are validated before
    people: Array,

    product: String,
  },
  setup () {
    return {
      v$: useValidate({ $autoDirty: true })
    }
  },
  watch: {
    'configuration.travellers_count': function (value) {
      this.formData.travellers = [];
      for (let i = 0; i < value; i++) {
        this.addPerson();
      }
    }
  },
  data: function () {
    return {
      formData: {
        uuid: null,
        name: null,
        surname: null,
        address: {
          street: null,
          street_number: null,
          town: null,
          zip: null
        },
        national_id: null,
        nationality: null,
        id_card: null,

        tel: null,
        email: null,
        action_code: null,
        agree_gdpr_basic: null,
        payment_protection: null,
        seller_code: null,

        // name: 'test',
        // surname: 'test',
        // address: {
        //   street: 'test',
        //   street_number: 'test',
        //   town: 'test',
        //   zip: '94102'
        // },
        // national_id: 'test',
        // nationality: 'SK',
        // id_card: 'test',
        // //insurance_from: null,
        //
        // tel: '+421 950 403 596',
        // email: 'test@test.com',
        // action_code: null,
        // agree_gdpr_basic: true,
        // payment_protection: true,
        // seller_code: null,

        golf_id: null,
        travellers: []
      },
      sending: false,
      submitError: null,
      countryList: null,
    };
  },
  validations() {
    return {
      formData: {
        name: {required},
        surname: {required},
        address: {
          street: {required},
          street_number: {required},
          town: {required},
          zip: {required, zipRule}
        },
        national_id: {required, nationalIdRule,
          matured(){
          return !this.formData.national_id || !rodnecislo(this.formData.national_id).isValid() || rodnecislo(this.formData.national_id).age() >= 18;
        }},
        nationality: {required},
        id_card: {required, alphaNum},
        // insurance_from: {required},
        seller_code: {},
        action_code: {},

        tel: {telRule},
        email: {required, email},
        agree_gdpr_basic: {required, checkRule},
        payment_protection: {required, checkRule},

      }
    }
  },
  computed: {
    language(){
      return this.$i18n.locale === 'cz' ? 'cs': this.$i18n.locale;
    },
    nationalIdObj(){
      return rodnecislo(this.formData.national_id);
    },
    // insuranceStartMin(){
    //   var date = new Date();
    //   //tomorrow
    //   date.setDate(date.getDate() + 1)
    //   return date;
    // },
    // price(){
    //   //standard
    //   const price_mode = this.formData.golf_id ? 'discounted' : 'standard';
    //   return this.formData.product_variant ? this.prices[this.formData.product_variant][price_mode] : null;
    // },
    priceFormatted(){
      return this.formatPrice(this.price);
    },
    tripCancellationFormatted(){
      return this.configuration.trip_cancellation_coverage ? this.formatPrice(this.configuration.trip_cancellation_coverage) : "nedojednané";
    },

  },

  methods: {
    canAdd(){
      return this.formData.travellers.length < 4;
    },
    addPerson(){
      this.formData.travellers.push(this.createPerson())
    },
    createPerson(){
      return {
        "id": "rand_" + Math.round(Math.random() * 1000),
        "name": null,
        "birthday_date": null,
      }
    },
    loadPersonFromOrder(){
      //console.log({"test": this.formData.national_id && rodnecislo(this.formData.national_id)?.birthDate()});
      let  date = null;
      let formatted_date = null;
      if (this.formData.national_id) {
        date = rodnecislo(this.formData.national_id)?.birthDate();
        if (date) {
          formatted_date = date.getFullYear() + '-' + ('0' + (date.getMonth()+1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
        }
      }
      console.log(formatted_date);
      let traveller = this.formData.travellers[0];
      traveller.name = this.formData.name;
      traveller.surname = this.formData.surname;
      traveller.birthday_date = formatted_date;
    },
    getCountryList(){
      return countries.getNames(this.language, {select: "official"});
    },
    formatPrice(price){
      return new Intl.NumberFormat('sk-SK', {
        style: 'currency',
        currency: 'EUR'
      }).format(price);
    },
    nationalIdValidity() {
      return this.nationalIdObj.isValid();
    },
    ageCheck(){
      return this.nationalIdObj.age() <= 70;
    },
    sendDataToServer(){
      var self = this;
      this.submitError = null;
      this.v$.$touch();
      this.touchTravellerValidation();
      if (this.sending || this.hasValidationErrors()) {
        if (this.hasValidationErrors()) {
          this.submitError = this.$t('validation.form_incomplete');
        }
        return;
      }
      this.sending = true;
      return axios.post(common.API_BASE_URL + this.product + '/' + this.$i18n.locale + '/order', {
        ...this.formData,...this.configuration,
        price: this.price
      })
          .then(response => {
            const data = response.data;
            this.formData.uuid = data.uuid;
            this.$router.push({path: '/order/'+ data.uuid + '/payment/ordered'});
          })
          .catch(error => {
            this.submitError = this.extractServerError(error);
          }).finally(() => { self.sending = false})
    },
    touchTravellerValidation() {
      const companions = this.$refs.tripCompanions;
      if (!companions) return;
      const list = Array.isArray(companions) ? companions : [companions];
      list.forEach((companion) => companion.v$.$touch());
    },
    hasValidationErrors() {
      if (this.v$.$errors.length) return true;
      const companions = this.$refs.tripCompanions;
      if (!companions) return false;
      const list = Array.isArray(companions) ? companions : [companions];
      return list.some((companion) => companion.v$.$errors.length);
    },
    extractServerError(error) {
      const data = error?.response?.data;
      if (typeof data === 'string' && data.trim()) return data;
      if (data?.message) return data.message;
      if (typeof data?.error === 'string') return data.error;
      if (Array.isArray(data?.errors)) return data.errors.join(' ');
      if (data?.errors && typeof data.errors === 'object') {
        return Object.values(data.errors).flat().join(' ');
      }
      if (data?.detail) return data.detail;
      return this.$t('validation.server_error');
    }
  },

  mounted() {
    console.log('Application Component mounted.');
    this.countryList = this.getCountryList();
    if (!this.formData.nationality) {
      this.formData.nationality = this.$i18n.locale.toUpperCase();
    }
    this.addPerson();
  }
}
</script>

<style scoped>
button{
  cursor: pointer;
}
.submit-actions {
  margin-top: 1em;
}
.submit-error {
  color: red;
  font-size: 0.95em;
  margin-bottom: 0.75em;
  max-width: 600px;
}
</style>
<style>
.d-block{
  display: block !important;
}
.invalid-feedback{
  color: red;
  font-size: 0.85em;
  margin-top: -0.3em;
  display: none;
}
input.is-invalid{
  border-color: red;
}
input.is-invalid +
.invalid-feedback{
  display: block;
}
table td{
  padding: 0 0.75em 0 0;
}
table tr td{
  text-align: left !important;
  vertical-align: top;
  max-width: 600px;
}
.national-id-wrapper .invalid-feedback{
  display: block;
}
</style>